export default __webpack_public_path__ + "static/media/SubheadingIcon.68e761ac.svg";